import React from "react"
import { useSelector } from "react-redux"
import { Route, Redirect } from "react-router-dom"
import LayoutView from "../components/common/basicLayout/LayoutView"
import { ROUTES, usePermissions } from "../utils"

const checkPageAccess = (hasPermission, permissions, accessToken) => {
	let isUserAuthorised = false
	let hasPageLevelPermission = false

	// If permittedPages exists
	if (!_.isEmpty(accessToken)) {
		isUserAuthorised = true
	}
	if (hasPermission(permissions)) {
		hasPageLevelPermission = true
	}

	return {
		isUserAuthorised,
		hasPageLevelPermission,
	}
}

const ProtectedRoute = ({ component: Component, roles, permissions, ...rest }) => {
	const accessToken = useSelector((state) => state?.authtentication?.user?.token?.access_token)
	const { hasPermission } = usePermissions()
	const checkAccess = checkPageAccess(hasPermission, permissions, accessToken)
	return (
		<Route
			{...rest}
			render={(props) => {
				// check if route is restricted by role
				if (checkAccess?.isUserAuthorised) {
					if (!checkAccess?.hasPageLevelPermission) {
						return <Redirect to={{ pathname: ROUTES.PAGE_NOT_FOUND }} />
					}
				} else {
					return <Redirect to={{ pathname: ROUTES.DEFAULT }} />
				}

				// authorized so return component
				return (
					<LayoutView>
						<Component {...props} />
					</LayoutView>
				)
			}}
		/>
	)
}

export default ProtectedRoute
